import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-history',
  templateUrl: './detail-history.component.html',
  styleUrls: ['./detail-history.component.scss']
})
export class DetailHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
